/* eslint-disable no-useless-computed-key */
import { MenuItem, TextField, Typography, withStyles } from '@material-ui/core';
import ReactRouterPropTypes from 'react-router-prop-types';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';

import { GET_CLIENTS_FAILURE } from 'modules/clients/types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from '../layout/types';
import { getTestApiV2, setPageTitle, showToast } from 'modules/layout/layout.actions';
import Log from 'utilities/log';
import { Box, Button } from '@mui/material';
import { getAllEnumerations } from 'modules/enumerations/store/enumerationActions';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { getFeeSummaries } from './fees.actions';
import { GET_FEE_SUMMARIES_FAILURE } from './fees.types';
import FeesGrid from './feesGrid.component';
import { getClients } from 'modules/clients/clients.actions';
// import { getInternalUsers } from 'modules/clients/clients.actions';
import CreateFeeDialog from './createFeeDialog.component';
import { getAuthorizationSummaries } from 'modules/authorizations/store/actions/authorizations.actions';
import { GET_AUTHORIZATIONS_FAILURE } from 'modules/authorizations/store/types/authorizationTypes'
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

const styles = (theme) => ({
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 100,
  },
});

class FeeSummariesView extends PureComponent {
  state = {
    isChangingStatusOfRecords: false,
    showChangeStatuses: false,
    showChangeStatusesModal: false,
    clientId: -1,
    startDate: '',
    endDate: '',
    selectedStatuses: ['d29d41c4-7285-42ae-9262-3e24e61c1af9'],
    initialLoad: false,
    isLoading: false,
    showCreateFee: false
  };

  async componentDidMount() {
    this.props.setPageTitle('Fees');
    this.setState({ initialLoad: true });

    if (!this.props.enumerations.allEnums) {
      await this.props.getAllEnumerations();
    }

    if (!this.props.fees) {
        const { type } = await this.props.getFeeSummaries();
        if (type === GET_FEE_SUMMARIES_FAILURE)
          this.props.showToast('Failed to retrieve fees, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }


    // if (!this.props.internalUsers) {
    //   let { type } = await this.props.getInternalUsers();
    //   if (type === GET_INTERNAL_USERS_FAILURE) {
    //     this.props.showToast('Failed to retrieve data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    //   }
    // }

    if (!this.props.unmappedClients?.length) {
      let { type } = await this.props.getClients();
      if (type === GET_CLIENTS_FAILURE) {
        this.props.showToast('Failed to retrieve data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } 
    }

    if (!this.props.authorizationSummaries) {
      let { type } = await this.props.getAuthorizationSummaries();
      if (type === GET_AUTHORIZATIONS_FAILURE) {
        this.props.showToast('Failed to retrieve authorizations, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    // Test first request to Intake API V2
    // await this.props.getTestApiV2();
  }

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  filterFees = (fees, selectedStatuses, clientId, startDate, endDate, authorizationSummaries = []) => {
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
    if (end) end.setUTCHours(23, 59, 59, 999);
    const authorizationsById = new Map(
      authorizationSummaries
        .filter(authorization => authorization.fileId != null)
        .map(authorization => [String(authorization.fileId), authorization])
    );

    return fees.filter((fee) => {
      const authorization = authorizationsById.get(String(fee.authorizationFileId));
      const matchesClient = Number(clientId) === -1 ||
        (authorization?.clientRecordId != null && String(authorization.clientRecordId) === String(clientId));
      const initDate = fee.fileInitDate ? new Date(fee.fileInitDate) : null;
      const matchesStart = !start || (initDate && initDate >= start);
      const matchesEnd = !end || (initDate && initDate <= end);
      return selectedStatuses.includes(fee.feeStatusId) && matchesClient && matchesStart && matchesEnd;
    });
  };

  render() {
    Log.trace('RENDER', 'FeesView');
    const { clientId, startDate, endDate, selectedStatuses, showChangeStatuses, showChangeStatusesModal, initialLoad, isLoading } = this.state;
    const { classes, managerOptions, profile, fees, history, enumerations, clients, unmappedClients, authorizationSummaries } = this.props;

    const canReadFees = hasPermission(Permissions.Finance.Fees.Read);

    if (!canReadFees) {
      history.push('/');
      return null;
    }

    const filteredFees = this.filterFees(fees || [], selectedStatuses, clientId, startDate, endDate, authorizationSummaries || []);
    
    const sortedClients = [...(unmappedClients?.length ? unmappedClients : Object.values(clients || {}))]
      .sort((first, second) => String(first.shortName || '').localeCompare(String(second.shortName || '')));

    // const changeStatusFilters = useCallback(
    //   label => this.setState({ selectedStatuses: (selectedStatuses.includes(label) ? selectedStatuses.filter(s => s !== label) : [...selectedStatuses, label]) }),
    //   [selectedStatuses]
    // );

    const feeStatuses =
      enumerations && enumerations.allEnums && enumerations.allEnums.feeStatuses.length > 0
        ? enumerations.allEnums.feeStatuses.filter(s => s.isActive === true)
        : [];

    const feeStatusReasons =
      enumerations && enumerations.allEnums && enumerations.allEnums.feeStatusReasons && enumerations.allEnums.feeStatusReasons.length > 0
        ? enumerations.allEnums.feeStatusReasons.filter(s => s.isActive === true)
        : [];

    const feeTypes =
      enumerations && enumerations.allEnums && enumerations.allEnums.feeBatchTypes.length > 0
        ? enumerations.allEnums.feeBatchTypes.filter(s => s.isActive === true)
        : [];

    const currentUserHasClients = profile && managerOptions && this.currentUserHasClients(managerOptions, profile.moveTrackUsername);

    if (initialLoad && currentUserHasClients) {
      this.setState({ managerId: 'My Clients', initialLoad: false });
    }

    return (
      <Fragment>
          <div className={classes.headerContainer}>
        <TextField
          select
          label="Clients"
          className={classes.textField}
          value={clientId}
          onChange={e => this.setState({ clientId: Number(e.target.value) })}
          SelectProps={{ autoWidth: true }}
          variant="outlined"
        >
          <MenuItem value={-1}>
            <em>All Clients</em>
          </MenuItem>
          {sortedClients.map(option => (
            <MenuItem key={option.clientRecordId} value={option.clientRecordId}>
              {option.shortName}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          type="date"
          label="Start Date"
          className={classes.textField}
          value={startDate}
          onChange={e => this.setState({ startDate: e.target.value })}
          SelectProps={{ autoWidth: true }}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          type="date"
          label="End Date"
          className={classes.textField}
          value={endDate}
          onChange={e => this.setState({ endDate: e.target.value })}
          SelectProps={{ autoWidth: true }}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        />
      </div>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: '10px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', py: '8px' }}>
          <Typography>Fee Status:</Typography>
          {feeStatuses.map(label => {
            const active = selectedStatuses.includes(label.id);
            if(label.id !== '00000000-0000-0000-0000-000000000000')
            {
            return (
              <Button
                key={label}
                color="secondary"
                variant="contained"
                sx={{
                  maxHeight: '40px',
                  backgroundColor: active ? '#36939b' : '#ffffff',
                  '&:hover': { backgroundColor: active ? '#15585e' : '#faf8f2' },
                  color: active ? '#ffffff' : '#080600'
                }}
                onClick={() => this.setState({ selectedStatuses: (selectedStatuses.includes(label.id) ? selectedStatuses.filter(s => s !== label.id) : [...selectedStatuses, label.id]) })}
              >
                {label.title}
              </Button>
            );
            }
            else {
              return (
                <div></div>
              )
            }
            
          })}
        </Box>
            {/* <Button
              color="secondary"
              variant="contained"
              sx={{
                maxHeight: '40px',
                marginRight: '10px',
                marginTop: '8px',
                backgroundColor: '#5D9878',
                '&:hover': { backgroundColor: '#528569' }
              }}
              onClick={() => this.setState({ showCreateFee: true })}
            >
              {' '}Create Fee Record{' '}
            </Button> */}
        
      </Box>

      {isLoading && <FullscreenSpinner />}
      {!isLoading && (
        <div className="px-2">
          <FeesGrid fees={filteredFees} isReadOnly={canReadFees} feeStatuses={feeStatuses} feeStatusReasons={feeStatusReasons} classes={classes} handleChange={this.handleChange} showChangeStatuses={showChangeStatuses} showChangeStatusesModal={showChangeStatusesModal} history={history} enumerations={enumerations.allEnums} />
        </div>
      )}
      {enumerations.allEnums && enumerations.allEnums.clientStatusTypes && (
        <CreateFeeDialog
          open={this.state.showCreateFee}
          onCancel={() => this.setState({ showCreateFee: false })}
          history={this.props.history}
          clients={clients ?? []}
          authorizations={this.props.authorizationSummaries ?? []}
          feeStatuses={feeStatuses ?? []}
          feeStatusReasons={feeStatusReasons ?? []}
          feeTypes={feeTypes ?? []}
        />
      )}

      </Fragment>
    );
  }
}

FeeSummariesView.propTypes = {
  setPageTitle: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  fees: PropTypes.array,
  unmappedClients: PropTypes.array,
  getClients: PropTypes.func.isRequired,
  getFeeSummaries: PropTypes.func.isRequired,
  // getInternalUsers: PropTypes.func.isRequired,
  isLoadingClients: PropTypes.bool.isRequired,
  isLoadingAuths: PropTypes.bool.isRequired,
  showToast: PropTypes.func.isRequired,
  profile: PropTypes.object,
  managerOptions: PropTypes.array,
  // internalUsers: PropTypes.array,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapStateToProps = (state) => {
  const {
    authorizations: { authorizationSummaries },
    intake: { ['isLoading']: isLoadingAuths },
    clients: { ['isLoading']: isLoadingClients, clients, unmappedClients },
    auth: { profile },
    fees: { fees },
    enumerations
  } = state;
  return { isLoadingClients, authorizationSummaries, isLoadingAuths, clients, unmappedClients, profile, fees, /* internalUsers, */ enumerations };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    setPageTitle,
    getClients,
    getAuthorizationSummaries,
    showToast,
    // getInternalUsers,
    getTestApiV2,
    getAllEnumerations,
    getFeeSummaries
  }),
)(FeeSummariesView);